// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sheet-container[data-v-769ab130]{height:calc(100vh - 24px);position:relative}.container-fluid[data-v-769ab130]{margin-left:34px;margin-right:83px}", ""]);
// Exports
module.exports = exports;
